import React from 'react';
import { useState, useRef } from 'react';
import useOnClickOutside from '../../../hooks/useOnClickOutside';
import { Trans } from '@lingui/macro';
import { EStatisticsGenderType } from '../../../../reducers/data';
import SmallGenderTypeTitle from '../statistics/SmallGenderTypeTitle';

interface IProps {
    selected?: EStatisticsGenderType,
    allowed: EStatisticsGenderType[],
    onSelect: (type: EStatisticsGenderType) => void
}

const FilterGenderType: React.FC<IProps> = (props) => {
    const ref = useRef<HTMLDivElement>(null)
    
    const [show, setShow] = useState(false)
    
    useOnClickOutside(ref, () => {
        setShow(false)
    })

    if(props.allowed.length === 0) {
        return null
    }
    
    return (
        <div className={`element_drop basic to_center col_default offset ${show?'active':''}`} ref={ref}>
            <button 
                type="button" 
                className="btn_basic element_drop_button"
                onClick={() => {
                    setShow(!show)
                }}
            >
                <span><Trans>Typ výstupu</Trans></span>
                <svg className="sico drop"><use xlinkHref="/assets/layout/icons.svg#s_ar1_d" /></svg>
            </button>  
            <div className="element_drop_inner">
                <div className="element_drop_arrow"></div>
                <div className="element_drop_content btn_interval_list pd-20">
                    {props.allowed.map((g,i) => (
                        <label key={i} className="btn_interval_label">
                            <input 
                                type="radio" 
                                name={`gender_type${i}`} 
                                checked={props.selected === g} 
                                onChange={(e) => {
                                    if(e.target.checked) {
                                        props.onSelect(g)
                                    }
                                    setShow(false)
                                }}
                            />
                            <div className="btn_interval dflex">
                                <span><SmallGenderTypeTitle type={g}/></span> 
                            </div>
                        </label>
                    ))}
                </div>
            </div>                       
        </div> 
    )
}

export default FilterGenderType